import axios from './index';

/**
 * Types
 */
import type { Response } from '@/dtos/common.dto';

/**
 * APIs
 */
export function me() {
    return axios<Response>('/v1/users/me');
}
